/** @module csi/action/PopupController */
define([
	"dojo/_base/connect",
	"dojo/_base/declare",
	"csi/action",
	"csi/action/Controller",
	"csi/def",
	"csi/locale",
	"csi/service/writerService",
	"csi/utility/routerUtility",
], function(connect, declare, csiAction, Controller, def, locale, {registerWriterCallback}, routerUtility) {

	return declare(Controller, {
		/**
		 * @property {boolean} popupForceBrowse - set to true to allow links within popup view;
		 * Don't use it on popups with tabs - it will conflict with tabs changing browser hash
		 */
		popupForceBrowse: false,

		/** @property {string} popupLinkTarget - target window when browsing in popup view */
		popupLinkTarget: null,

		// String: page location when popup is entered
		_hash: null,

		// Object: handle for subscription to changes in popup view
		_topicAction: null,

		onFormData: function(fd) {
			// summary: allow editing in popup view
			fd.m_bEditable = true;
			fd.m_bAllowSelections = false;
			fd.m_bAllowSelectionActions = false;

			if (this.popupLinkTarget != null) {
				fd.linkTarget = this.popupLinkTarget;
			}

			// make view read-only if popped up from read-only context
			// FIX: might be better to just store readOnly status with element
			var url;
			var refNode = this.widget.getRefNode(this.refNode || this.m_element);
			if (refNode) {
				url = this.widget.getRefNodeUrl(refNode);
			}

			var ctx = this.widget.getContext(url);

			if (this.heading) {
				ctx.push(this.heading.m_path);
			}

			if (ctx.isReadOnly()) {
				fd.m_bEditable = false;
			}
		},

		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			// summary: popup view adds a Close button to the current list of view actions and forces them to all be buttons
			defActions.m_actions = defView.m_defActions?.m_actions || [];
			defActions.m_actions.forEach((a) => {
				a.m_typeControl = def.ACTION_BUTTON;
			});

			defActions.addAction(this.getProxyAction("Close"));
		},

		openDialog: function(/*ActionView*/av) {
			// summary: popup view
			this._hash = routerUtility.captureHash();
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Change closeTitle to "Close" rather than default of "Cancel"
		 */
		onCreatePopupDialogParams: function(dialogParams) {
			dialogParams.closeTitle = locale.resource("Close");
		},

		onLoadPopup: function(/*csi.view.Widget*/view) {
			// summary: finish processing popup view

			// subscribe to any actions in view and cache in calling view's cache
			this._topicAction = registerWriterCallback((res) => this._onTopicActionResponse(res));

			// post-processing needed when dialog is closed
			connect.connect(view, "uninitialize", this, this._onDestroyPopup);

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Since popup action only has close action, the cancel button in top-right of dialog should do the same as Close button 
		 */
		_onCancelPopup: function() {
			if (this.isSuspended()) {
				csiAction.stopNonModalAction();
				this.resumeProcess();
				this.process();
			}
		},

		_onDestroyPopup: function() {
			// summary: cleanup
			this._topicAction?.remove();
			this._topicAction = null;

			if (!this.popupForceBrowse) {
				routerUtility.replaceHash(this._hash);
			}
		},

		/**
		 * Cache changes in view that invoked popup
		 * @param {JsonResponse} res 
		 */
		_onTopicActionResponse(res) {
			this.m_cache.cacheResponse(res);
		},

		/**
		 * @override
		 * set appropriate view changes for this controller type
		 */
		_onCreatePopup: function(view) {
			if (this.popupForceBrowse) {
				view.set("bForceBrowse", true);
			}

			this.inherited(arguments);
		}
	});
});